import styled from 'styled-components';

import { Header as CoreHeader, HeaderActions } from '@components/header';
import { useIsMobile } from '@hooks/use-is-mobile';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

import { MobileHeader } from 'components/mobile-header';

type HeaderProps = {
  actions?: JSX.Element;
  breadcrumbs?: JSX.Element;
  tabs?: JSX.Element;
  mobileTitle?: string;
  selectionHeader?: JSX.Element;
  showSelectionHeader?: boolean;
};

export const Header = (props: HeaderProps) => {
  const { actions = null, tabs = null, mobileTitle = '' } = props;
  const isMobile = useIsMobile();
  if (isMobile) {
    return (
      <div>
        <MobileHeader title={mobileTitle} />
        {tabs && <MobileTabsContainer>{tabs}</MobileTabsContainer>}
        {actions && <HeaderActions>{actions}</HeaderActions>}
      </div>
    );
  }

  return <CoreHeader {...props} />;
};

const MobileTabsContainer = styled.div({
  backgroundColor: theme.color.white100,
  padding: '1.5rem 1.5rem 0 1.5rem',
  overflowX: 'auto',
  maxWidth: '100vw',
  display: 'flex',
  alignItems: 'center',
  borderBottom: `${pxToRem(1)} solid ${theme.color.purple10}`,
});
